import { useScreen } from "../../../context/ScreenContext";
import type { UserConfigs } from "../../../db/db";
import MobileConfigsModal from "./_components/mobile";
import WebConfigsModal from "./_components/web";

type ModalProps = {
  onCancel: () => void;
  userConfigsDb: UserConfigs | '';
}

const ModalConfigs = ({ onCancel, userConfigsDb }: ModalProps) => {
  const { isMobile } = useScreen();

  return isMobile
    ? <MobileConfigsModal onCancel={onCancel} userConfigsDb={userConfigsDb} />
    : <WebConfigsModal onCancel={onCancel} userConfigsDb={userConfigsDb} />
}

export default ModalConfigs;
